/* eslint-disable global-require */
import "./assets/css/vendor/bootstrap.min.css";
import "./assets/css/vendor/bootstrap.rtl.only.min.css";
import "react-circular-progressbar/dist/styles.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-image-lightbox/style.css";
import "video.js/dist/video-js.css";
import {
  isMultiColorActive,
  defaultColor,
  isDarkSwitchActive,
  colors,
} from "./constants/defaultValues";
import { getCurrentColor, setCurrentColor } from "./helpers/Utils";

const isValidThemeColor = (value) => {
  if (!value || typeof value !== "string") return false;
  if (value === "light" || value === "dark") return true;
  const [mode, name] = value.split(".");
  return (
    (mode === "light" || mode === "dark") &&
    colors.includes(name)
  );
};

const color = (() => {
  const preferred =
    isMultiColorActive || isDarkSwitchActive ? getCurrentColor() : defaultColor;
  return isValidThemeColor(preferred) ? preferred : defaultColor;
})();
setCurrentColor(color);

const loadApp = () => {
  require("./AppRenderer");
};

const render = () => {
  import(`./assets/css/sass/themes/gogo.${color}.scss`)
    .then(loadApp)
    .catch((error) => {
      console.error(
        `Failed to load theme "gogo.${color}.scss", falling back to "${defaultColor}"`,
        error
      );
      setCurrentColor(defaultColor);
      import(`./assets/css/sass/themes/gogo.${defaultColor}.scss`)
        .then(loadApp)
        .catch((fallbackError) => {
          console.error("Failed to load fallback theme", fallbackError);
          loadApp();
        });
    });
};
render();
